/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Convert_SuccessInputs */



/**
* | output |
* | --- |
* | "Event group has been converted to subtitles." |
*
* @param {Event_Group_Options_Convert_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_convert_success = /** @type {((inputs?: Event_Group_Options_Convert_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Convert_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le groupe d'événements a été converti en sous-titres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisgruppe wurde in Untertitel umgewandelt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo di eventi è stato convertito in sottotitoli.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа событий преобразована в субтитры.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El grupo de eventos se ha convertido a subtítulos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组已转换为字幕。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループが字幕に変換されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह को उपशीर्षकों में परिवर्तित कर दिया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo de eventos foi convertido em legendas.")
	return /** @type {LocalizedString} */ ("Event group has been converted to subtitles.")
});